import { AssetImageDto, FieldTranslation } from '@floori-web-components';
import { ProductPlacementOptions } from '../product';

export interface RoomCategoryDto {
    readonly name: FieldTranslation;
    readonly icon: AssetImageDto;
}

export interface RoomGroupDto {
    readonly name: FieldTranslation;
    readonly categories: RoomCategoryDto[];
}

export interface RoomCategoryListDto {
    [key: string]: RoomDto;
}

export interface RoomDto {
    readonly id?: string;
    readonly name?: string;
    readonly groups?: RoomGroupDto[];
    readonly image?: AssetImageDto;
    readonly image4k?: string;
    readonly placementOptions?: ProductPlacementOptions[];
    readonly visitorRoom?: boolean;
}

export interface RoomCreateDto {
    readonly roomId: string;
    readonly visitorId: string;
    readonly room: RoomDto & { thumbnail: string };
}

export enum RoomPhotoOrientation {
    horizontal = 'horizontal',
    vertical = 'vertical',
}
